import { ShipmentComponent } from './shipment/shipment.component';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { DesignerModule } from './designer/designer.module';
import { SizeModule } from './size/size.module';
import { CustomerModule } from './customer/customer.module';
import { ProductModule } from './product/product.module';
import { CurrencyModule } from './currency/currency.module';
import { CourierModule } from './courier/courier.module';
import { DestinationModule } from './destination/destination.module';
import { AuthModule } from './auth/auth.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InventoryModule } from './inventory/inventory.module';
import { MainComponent } from './main.component';
import { LocationModule } from './location/location.module';
import { ProfileModule } from './profile/profile.module';
import { ProfileComponent } from './profile/profile.component';
import { ProductComponent } from './product/product.component';
import { CustomerComponent } from './customer/customer.component';
import { OrderComponent } from './order/order.component';
import { CategoryComponent } from './category/category.component';
import { SizeComponent } from './size/size.component';
import { DesignerComponent } from './designer/designer.component';
import { StyleComponent } from './style/style.component';
import { StatusComponent } from './status/status.component';
import { ConditionComponent } from './condition/condition.component';
import { CollectionComponent } from './collection/collection.component';
import { ProcessTypesComponent } from './process-types/process-types.component';
import { ProcessStatusComponent } from './process-status/process-status.component';
import { ProcessTransitionComponent } from './process-transition/process-transition.component';
import { ProviderComponent } from './provider/provider.component';
import { CurrencyComponent } from './currency/currency.component';
import { CourierComponent } from './courier/courier.component';
import { AclComponent } from './acl/acl.component';
import { UserModule } from './user/user.module';
import { UserComponent } from './user/user.component';
import { CollectionBarcodeComponent } from '../common/print-template/collection-barcode/collection-barcode.component';
import { BarcodeComponent } from '../common/print-template/product-barcode/barcode.component';
import { PrintTemplateModule } from '../common/print-template/print-template.module';
import * as _ from 'lodash';
import { ColorComponent } from './color/color.component';
import { ColorModule } from './color/color.module';
import { WardrobeComponent } from './wardrobe/wardrobe.component';
import { WardrobeModule } from './wardrobe/wardrobe.module';
import { DeliveryModule } from './delivery/delivery.module';
import { DeliveryComponent } from './delivery/delivery.component';
import { PaymentModule } from './payment/payment.module';
import { PaymentComponent } from './payment/payment.component';
import { CouponComponent } from "./coupon/coupon.component";
import { CouponModule } from "./coupon/coupon.module";
import { CartruleComponent } from "./cartrule/cartrule.component";
import { CartruleModule } from "./cartrule/cartrule.module";
import { ProcessStatusGroupComponent } from "./process-status-group/process-status-group.component";
import { ProcessStatusGroupModule } from "./process-status-group/process-status-group.module";
import { CustomAttributeComponent } from "./custom-attribute/custom-attribute.component";
import { CustomAttributeModule } from "./custom-attribute/custom-attribute.module";
import { CustomAttributeOptionComponent } from "./custom-attribute-option/custom-attribute-option.component";
import { CustomAttributeOptionModule } from "./custom-attribute-option/custom-attribute-option.module";

@NgModule({
  imports: [
      CustomAttributeOptionModule,
      CustomAttributeModule,
    ProcessStatusGroupModule,
    CartruleModule,
    CouponModule,
    WardrobeModule,
    ColorModule,
    CommonModule,
    RouterModule,
    FormsModule,
    InventoryModule,
    LocationModule,
    AuthModule,
    DestinationModule,
    ProfileModule,
    ProductModule,
    CustomerModule,
    SizeModule,
    DesignerModule,
    UserModule,
    CurrencyModule,
    CourierModule,
    SweetAlert2Module,
    PrintTemplateModule,
    DeliveryModule,
    PaymentModule
  ],
  entryComponents: [BarcodeComponent, CollectionBarcodeComponent],
  declarations: [
      CustomAttributeOptionComponent,
      CustomAttributeComponent,
    ProcessStatusGroupComponent,
    CartruleComponent,
    CouponComponent,
    WardrobeComponent,
    ColorComponent,
    PageNotFoundComponent,
    DashboardComponent,
    MainComponent,
    ProfileComponent,
    ProductComponent,
    CustomerComponent,
    OrderComponent,
    CategoryComponent,
    SizeComponent,
    DesignerComponent,
    StyleComponent,
    StatusComponent,
    ConditionComponent,
    CollectionComponent,
    ProcessTypesComponent,
    ProcessStatusComponent,
    ProcessTransitionComponent,
    AclComponent,
    ShipmentComponent,
    UserComponent,
    ProviderComponent,
    CurrencyComponent,
    CourierComponent,
    DeliveryComponent,
    PaymentComponent
  ],
  exports: []
})
export class ComponentsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ComponentsModule
    };
  }
}
